export abstract class ServiceModelBase {
    createdOnUTC!: Date;
    lastModifiedOnUTC?: Date;
}
